<template>
    <div class="adminMobileTransfer">
        <div class="sucssInfo">
            <span class="icon-al-exclamation-circle"></span>
            <p>为了让您有更好的使用体验，我们建议您在电脑端使用</p>
            <div class="btn" @click="copyLink">复制链接</div>
        </div>
    </div>
</template>
<script>
export default {
    name:'adminMobileTransfer',
    data() {
        return {
            
        }
    },
    created () {
        
    },
    methods: {
        // 复制链接
        copyLink(){
                let str = this.$route.query.type == 8 ? this.$config.prUrl + '#/teacheManage/dashboard' : this.$route.query.type == 9 ?  this.$config.prUrl + '#/myExam/courseAll': ''
                let _self = this
                this.$copyText(str).then(
                    function(e) {
                      _self.$util.Notifi('复制成功','success','fa-check')
                    },
                    function(e) {
                    _self.$util.Notifi('复制失败','error','fa-exclamation-circle'); 
                    }
                )
        },
        openBuss(){
            this.$router.push('/webenterprise/enBusiness')
        },
    },

}
</script>
<style lang="scss" scoped>
.adminMobileTransfer{
    text-align: center;
    padding-top: 100px;
    span{
        font-size: 60px;
        color: rgb(0,172,132);
    }
    .btn{
        width: 150px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: rgb(0,172,132);
        border-radius: 5px;
        margin: 100px auto;
        color: #fff;
    }
    .jxsee{
       color: rgb(0,172,132); 
       position: absolute;
       bottom: 50px;
       width: 100%;
    }
}
</style>